import { useAtomValue } from 'jotai';
import {
  bookingTripTimeAtom,
  isBookingMultiDayAtom,
  selectedBookingPackageAtom,
  tripStartFormattedAtom,
} from 'components/forms/bookingWidget/jotaiStore';
import styled from 'styled-components';
import { useEffect } from 'react';
import SelectInput from '../../TimePicker/SelectInput';
import DurationIcon from './DurationIcon';
import {
  calculateAvailableLengthOptions,
  findBestAvailableDuration,
  getAvailableDurationsForDate,
  getBoatAvailableOptions,
} from './utils';

const DurationPicker = ({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars,unused-imports/no-unused-vars
  onChange = (e) => {},
  defaultValue,
  setter,
  error = null,
  className = null,
  modalVersion = false,
  calendar,
}) => {
  const isBookingMultiDay = useAtomValue(isBookingMultiDayAtom);
  const selectedBookingPackage = useAtomValue(selectedBookingPackageAtom);
  const tripTime = useAtomValue(bookingTripTimeAtom);
  const tripStartFormatted = useAtomValue(tripStartFormattedAtom);

  // Effect to auto-adjust duration when it's preselected but not available
  useEffect(() => {
    if (!defaultValue || !calendar || !selectedBookingPackage || !tripStartFormatted) return;

    const availableDurationsForDate = getAvailableDurationsForDate({
      startDate: tripStartFormatted,
      calendarInfo: calendar,
      selectedPackage: selectedBookingPackage,
    });

    const currentDurationValue = defaultValue?.value || defaultValue;
    const bestDuration = findBestAvailableDuration(currentDurationValue, availableDurationsForDate);

    // If we need to change the duration and we have a setter
    if (bestDuration !== null && bestDuration !== currentDurationValue && setter) {
      const boatOptions = getBoatAvailableOptions(selectedBookingPackage);
      const newDurationOption = boatOptions.find((option) => option.value === bestDuration);

      if (newDurationOption) {
        setter(newDurationOption);
        onChange(newDurationOption);
      }
    }
  }, [defaultValue, calendar, selectedBookingPackage, tripStartFormatted]);

  const options = calculateAvailableLengthOptions({
    startDate: tripStartFormatted,
    startTime: tripTime?.value,
    calendarInfo: calendar,
    selectedPackage: selectedBookingPackage,
  });

  return (
    <DurationPickerWrapper data-testid="pdp-booking-widget-duration-picker-container">
      <SelectInput
        modalVersion={modalVersion}
        setter={setter}
        name="DurationPicker"
        object="duration_picker"
        error={error}
        options={options}
        icon={<DurationIcon />}
        className={className}
        defaultValue={defaultValue}
        onChange={onChange}
        title="Duration"
        height="auto"
        isDisabled={isBookingMultiDay}
      />
    </DurationPickerWrapper>
  );
};

const DurationPickerWrapper = styled.div`
  margin-bottom: 0px;
`;

export default DurationPicker;
